<template>
	<page-container class="container container-contact no-heading-image no-video" :page="page">
		<main-content :title="(page.title || page.header) ?? 'Page not found'" :content="page.content">
			<div class="columns column6 align-left">
				<h1 v-if="!page.headingImage">{{ page.title || page.header }}</h1>
				<wysiwyg-content :content="page.content" />
			</div>
			<div class="columns column6">
				<div class="form-wrapper">
					<wysiwyg-content :content="defaults[locale].website.groupsFormContent" />
					<button class="form-toggle" @click="expanded = !expanded">
						{{ defaults[locale].website.groupsFormButton }}
					</button>
					<slide-up-down v-model="expanded" :duration="400">
						<div class="content">
							<contact-form v-if="form" name="contact" :form="form" />
						</div>
					</slide-up-down>
				</div>
			</div>
		</main-content>

		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>

		<footer-image>
			<div class="row maps-row">
				<div class="columns column12 align-right">
					<iframe
						src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2436.497068662414!2d4.922151577003743!3d52.3614063479588!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c5e3fd5635ac85%3A0x9e68c21f5edd9c1f!2sDe%20Eeuwige%20Jeugd!5e0!3m2!1sen!2snl!4v1753361288247!5m2!1sen!2snl"
						width="100%"
						height="550"
						style="border: 0"
						allowfullscreen
						loading="lazy"
						referrerpolicy="no-referrer-when-downgrade"
					/>
				</div>
			</div>
		</footer-image>
	</page-container>
</template>

<script setup lang="ts">
const { page, fetchPage } = usePage();
const { locale } = useI18n();
const { defaults, fetchDefaults } = useDefaults();

await fetchPage();
await fetchDefaults();

const expanded = ref(false);

const { data: form } = await useWebsiteFetch<FormField[]>('contact', {
	query: { language: locale.value },
	key: `${locale.value}/contact`,
});

useHead({
	bodyAttrs: {
		class: 'contact subpage',
	},
});
</script>

<style lang="scss" scoped>
.form-toggle {
	outline: none;
	border: none;
	color: var(--primary-background-color);
	background: #fff;
	text-transform: uppercase;
	font-family: var(--heading-font-family);
	padding: 3px 9px 5px;
	cursor: pointer;
	font-size: 16px;
	letter-spacing: 2px;
	margin: 0 0 25px;
	transition: all 0.3s ease-in-out;

	&:hover {
		background: #fdf0f4;
	}
}

.form-wrapper {
	padding-top: 120px;
}

.form-row {
	.columns {
		padding: 0 25px;
	}
}

.maps-row {
	iframe {
		width: 100%;
		max-width: 700px;
		margin: 50px 0;
	}
}

h1 {
	margin-top: 30px;
}

.address {
	text-transform: uppercase;

	h2 {
		text-transform: none;
	}

	a {
		font-family: var(--body-font-family);
		font-weight: 400;
		text-decoration: none;
		font-size: var(--body-font-size);
	}
}

.section-reservations {
	padding-top: 0;
}

@media (max-width: 1280px) {
	.column6 {
		width: 100%;
	}

	.column2,
	.column4 {
		width: 50%;
	}

	.form-wrapper {
		padding-top: 20px;
	}
}

@media (max-width: 900px) {
	.maps-row {
		iframe {
			max-width: 100%;
		}
	}
}

@media (max-width: 640px) {
	.column2,
	.column4 {
		width: 100%;
	}
}
</style>
